import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { CallToActionButton } from '@finn-no/troika-react-buttons';

import { fetchResults } from '../../../state/resultActions';
import { actions as filterActions } from '../../../state/filterActions';

import { ApiQueryParams, PaleState } from '../../../interfaces';

interface Props {
    destinations: string[];
    triggerFetch: (queryParam?: ApiQueryParams) => void;
    removeDestination: (destination: string) => void;
}

export const destinationDisplayName = (destinationId: string): string =>
    destinationId ? [...new Set(destinationId.split(';').slice(1))].reverse().join(', ') : '';

export const DestinationList: React.FC<Props> = ({ triggerFetch, removeDestination, destinations }): ReactElement<Props> => {
    const removeDestinationAndFetch = (destination: string): void => {
        removeDestination(destination);
        triggerFetch();
    };

    return (
        <div className="u-mb32">
            {destinations.map((destination) => (
                <div key={destination} className="u-size1of1 u-mv8">
                    <CallToActionButton
                        small
                        className="max-width-100"
                        key={destination}
                        data-testid={`destinationButton-${destination}`}
                        onClick={(): void => removeDestinationAndFetch(destination)}>
                        <div className="flex flex-row">
                            <div className="u-truncate">{destinationDisplayName(destination)}</div>
                            <i className="image--cross-white" />
                        </div>
                    </CallToActionButton>
                </div>
            ))}
        </div>
    );
};

const mapStateToProps = (state: PaleState): Pick<Props, 'destinations'> => ({
    destinations: state.filters.destinations.list,
});

const mapDispatchToProps = {
    removeDestination: filterActions.removeDestination,
    triggerFetch: fetchResults,
};

export default connect(mapStateToProps, mapDispatchToProps)(DestinationList);
